import React, { useState } from "react";
import PropTypes from "prop-types";
import Popover from "react-popover";
import "./titleValueComponent.scss";

/**
 *
 * @description
 * title : To display title
 * value : To display value
 * hoverText : Text to show on hover of the icon
 * icon : To display icon
 *
 */

const TitleValueComponent = (props) => {
  const { customTextToHover } = props;

  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Actions ==>

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  // <===

  // Create UI ==>

  const displayHoverContent = () => {
    return (
      <div style={{ padding: "6px 10px", fontSize: "12px" }}>
        {props.hoverText}
      </div>
    );
  };

  const displayTitleValueComponentView = () => {
    return (
      <div className="title-value-component-container">
        <div>
          <span className="title-text">{props.title}</span>
        </div>
        {props.uhId && (
          <div>
            <span className="title-text">{props.uhId}</span>
          </div>
        )}
        <div className="title-value-container">
          <span className="value-text">{props.value}</span>
          {(props.icon || customTextToHover) && (
            <Popover
              isOpen={isOpen}
              preferPlace={`below`}
              place={null}
              anchorEl={anchorEl}
              body={displayHoverContent()}
            >
              {props.icon ? (
                <img
                  src={props.icon}
                  alt=""
                  style={{ cursor: "pointer", marginLeft: "6px" }}
                  onMouseOver={handlePopoverOpen}
                  onMouseOut={handlePopoverClose}
                />
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  onMouseOver={handlePopoverOpen}
                  onMouseOut={handlePopoverClose}
                >
                  {customTextToHover}
                </span>
              )}
            </Popover>
          )}
        </div>
      </div>
    );
  };

  // <===

  return <>{displayTitleValueComponentView()}</>;
};

TitleValueComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

export default TitleValueComponent;
